import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { Button, Card, Grid } from '@mui/material'
import Input from 'components/forms/Input'
import Checkbox from 'components/forms/Checkbox'
import MultiContributorsAutocomplete from 'referencial/components/contributor/components/MultiContributorsAutocomplete'
import SuperMultiAutocomplete from 'components/forms/SuperMultiAutocomplete'
import { isNil } from 'lodash'
import useListIndexed from '../../../../utils/customHook/useListIndexed'
import useLocalStorage from '../../../../utils/customHook/useLocalStorage'
import { emptyFilterUsers, FILTER_ADMIN_SEARCH } from '../constants/UserConstants'


const FormFilterUsers = ({
    onValidate = () => { },
    noCard = false,
    noApplicativeUsers = false,
}) => {
    const [tmpFilter, setTmpFilter] = useLocalStorage(FILTER_ADMIN_SEARCH, emptyFilterUsers)

    useEffect(() => {
        onValidate(tmpFilter)
    }, [])

    const {
        users,
        cities,
        contributors,
    } = useSelector(store => ({
        users: store.UserReducer.users,
        cities: store.CityReducer.cities,
        contributors: store.ContributorReducer.contributors,
    }), shallowEqual)

    const indexedCities = useListIndexed(users, 'townCode')
    const filteredCities = cities.filter(c => !isNil(indexedCities[parseInt(c.code)]))

    const indexedUsers = useListIndexed(users, 'contributorCode')
    const filteredContributors = contributors.filter(c => !isNil(indexedUsers[parseInt(c.code)]))

    const onReset = () => {
        onValidate(emptyFilterUsers)
        setTmpFilter(emptyFilterUsers)
    }

    const children = (
        <Grid container size={12} spacing={1} justifyContent='space-between'>
            <Grid size={4}>
                <Input
                    title={i18n.search}
                    value={tmpFilter.searchValue}
                    onChange={v => setTmpFilter({ ...tmpFilter, searchValue: v })}
                    onEnterKeyPress={() => onValidate(tmpFilter)}
                />
            </Grid>
            <Grid size={4}>
                <MultiContributorsAutocomplete
                    multiple
                    options={filteredContributors}
                    onChange={values => setTmpFilter({ ...tmpFilter, contributors: values })}
                    values={tmpFilter.contributors}
                />
            </Grid>
            <Grid size={4}>
                <SuperMultiAutocomplete
                    label={i18n.city}
                    options={filteredCities}
                    keyLabel='labelWithCode'
                    onChange={values => setTmpFilter({ ...tmpFilter, cities: values })}
                    values={tmpFilter.cities}
                    multiple
                />
            </Grid>
            <Grid container size='grow' spacing={3}>
                <Grid>
                    <Checkbox
                        label={i18n.admin}
                        checked={tmpFilter.isAdmin || false}
                        onChange={ v => setTmpFilter({ ...tmpFilter, isAdmin: v }) }
                    />
                </Grid>
                <Grid>
                    <Checkbox
                        label={i18n.administrator}
                        checked={tmpFilter.metadata || false}
                        onChange={ v => setTmpFilter({ ...tmpFilter, metadata: v }) }
                    />
                </Grid>
                <Grid>
                    <Checkbox
                        label={i18n.technicien}
                        checked={tmpFilter.labo || false}
                        onChange={ v => setTmpFilter({ ...tmpFilter, labo: v }) }
                    />
                </Grid>
                <Grid>
                    <Checkbox
                        label={i18n.consultant}
                        checked={tmpFilter.consultant || false}
                        onChange={ v => setTmpFilter({ ...tmpFilter, consultant: v }) }
                    />
                </Grid>
                {!noApplicativeUsers && (
                    <Grid>
                        <Checkbox
                            label={i18n.usersApplication}
                            checked={tmpFilter.applicativeUsers || false}
                            onChange={ v => setTmpFilter({ ...tmpFilter, applicativeUsers: v }) }
                        />
                    </Grid>
                )}
            </Grid>
            <Grid container size='auto' justifyContent='flex-end' alignItems='flex-end'>
                <Grid>
                    <Button variant='outlined' onClick={onReset}>
                        {i18n.reinit}
                    </Button>
                </Grid>
                <Grid>
                    <Button variant='contained' onClick={() => onValidate(tmpFilter)}>
                        {i18n.search}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    )

    return !noCard ? (
        <Card data-cy='usersFormFilter' sx={{ padding: 1 }}>
            {children}
        </Card>
    ) : children
}

FormFilterUsers.propTypes = {
    onValidate: PropTypes.func,
    noCard: PropTypes.bool,
    noApplicativeUsers: PropTypes.bool,
}

export default FormFilterUsers